export const iconColor = '#DE7FEF';